import type { UpgradeId } from '../game/types';

export interface UpgradeDefinition {
  id: UpgradeId;
  category: 'YASEMİN' | 'KAFE' | 'FEVZİ';
  icon: string;
  name: string;
  effect: string;
  basePrice: number;
  maxLevel: number;
  unlockDay: number;
}

export const UPGRADES: UpgradeDefinition[] = [
  { id: 'yasemin_speed', category: 'YASEMİN', icon: '↗', name: 'Hızlı Adımlar', effect: 'Yürüme hızı +%5', basePrice: 75, maxLevel: 5, unlockDay: 2 },
  { id: 'order_speed', category: 'YASEMİN', icon: '✎', name: 'Pratik Notlar', effect: 'Sipariş alma +%10 hızlı', basePrice: 65, maxLevel: 5, unlockDay: 2 },
  { id: 'cleanup_speed', category: 'YASEMİN', icon: '✦', name: 'Pırıl Pırıl', effect: 'Temizlik +%11 hızlı', basePrice: 65, maxLevel: 5, unlockDay: 2 },
  { id: 'coffee_speed', category: 'KAFE', icon: '☕', name: 'İyi Değirmen', effect: 'Sıcak içecekler +%8 hızlı', basePrice: 85, maxLevel: 5, unlockDay: 2 },
  { id: 'patience_bonus', category: 'KAFE', icon: '❀', name: 'Huzurlu Köşe', effect: 'Müşteri sabrı +5 sn', basePrice: 90, maxLevel: 5, unlockDay: 2 },
  { id: 'fevzi_speed', category: 'FEVZİ', icon: '⚡', name: 'Fevzi Hızlanıyor', effect: 'Yardım hareketi +%8 hızlı', basePrice: 95, maxLevel: 5, unlockDay: 4 },
  { id: 'fevzi_cooldown', category: 'FEVZİ', icon: '◷', name: 'Hazır Bekler', effect: 'Yardım bekleme süresi azalır', basePrice: 105, maxLevel: 5, unlockDay: 4 },
];

export const upgradePrice = (definition: UpgradeDefinition, level: number): number => Math.round(definition.basePrice * (1 + level * 0.7 + level * level * 0.15));
